<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.page_seo_name')">
        <b-input v-model="form.name" disabled expanded></b-input>
      </b-field>
      <b-field horizontal :label="$t('attributes.page_seo_url')">
        <b-input
          v-model="form.url"
          name="url"
          :placeholder="
            $t('message.please_input') + $t('attributes.page_seo_url')
          "
          expanded
        ></b-input>
      </b-field>
      <b-field horizontal :label="$t('attributes.page_seo_page_title')">
        <b-input
          v-model="form.page_title"
          type="textarea"
          name="page_title"
          maxlength="1500"
          rows="12"
          :placeholder="
            $t('message.please_input') + $t('attributes.page_seo_page_title')
          "
        ></b-input>
      </b-field>
      <b-field horizontal :label="$t('attributes.page_seo_meta_title')">
        <b-input
          v-model="form.meta_title"
          name="meta_title"
          type="textarea"
          maxlength="1500"
          rows="12"
          :placeholder="
            $t('message.please_input') + $t('attributes.page_seo_meta_title')
          "
        ></b-input>
      </b-field>
      <b-field horizontal :label="$t('attributes.page_seo_meta_keyword')">
        <b-input
          v-model="form.meta_keyword"
          name="meta_keyword"
          type="textarea"
          maxlength="1500"
          rows="12"
          :placeholder="
            $t('message.please_input') + $t('attributes.page_seo_meta_keyword')
          "
        ></b-input>
      </b-field>
      <b-field horizontal :label="$t('attributes.page_seo_meta_description')">
        <b-input
          v-model="form.meta_description"
          name="meta_description"
          type="textarea"
          maxlength="1500"
          rows="12"
          :placeholder="
            $t('message.please_input') +
              $t('attributes.page_seo_meta_description')
          "
        ></b-input>
      </b-field>
      <b-field horizontal>
        <b-button
          :loading="sending"
          type="is-primary"
          native-type="submit"
          size="is-medium"
          style="width: 100%"
        >
          {{ $t('attributes.update_data') }}
        </b-button>
      </b-field>
    </form>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { PAGE_SEO_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'PageSeo',
  props: {
    detail: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.detail)
    }
  },
  validations: {
    form: {
      id: { required },
      name: { required, maxLength: maxLength(50) },
      url: { required, maxLength: maxLength(50) },
      page_title: { maxLength: maxLength(1500) },
      meta_title: { maxLength: maxLength(1500) },
      meta_keyword: { maxLength: maxLength(1500) },
      meta_description: { maxLength: maxLength(1500) }
    }
  },
  watch: {
    detail(newDetail) {
      this.form = this.extractFormValues(newDetail)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        name: data.name,
        url: data.url,
        page_title: data.page_title || '',
        meta_title: data.title || '',
        meta_keyword: data.keyword || '',
        meta_description: data.description || ''
      }
    },
    async onSend() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      const api = `${PAGE_SEO_API}/seo`
      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)
        this.$emit('updated', res.data.data)
        //this.$emit('updated', true)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style scoped></style>
